import Cookies from 'js-cookie';

export interface CookieStore {
  get: () => string | null;
  set: (value: string) => void;
  clear: () => void;
}

const COOKIE_NAME = 'amsAuth';
// js-cookie cannot set HttpOnly, so the refresh token is JS-readable; this risk class
// matches MP's existing posture and was explicitly accepted. The real exposure bound is
// the AWS 30-day refresh_token_validity default, not this cookie's session lifetime. Any
// tightening is a platform-level decision that would need to cover MP too.
const COOKIE_OPTIONS = { secure: true, sameSite: 'Strict' as const };

export const cookieStore: CookieStore = {
  get() {
    return Cookies.get(COOKIE_NAME) ?? null;
  },
  set(value) {
    Cookies.set(COOKIE_NAME, value, COOKIE_OPTIONS);
  },
  clear() {
    Cookies.remove(COOKIE_NAME, COOKIE_OPTIONS);
  },
};
